import React from 'react';
import './Loader.scss';
import classNames from 'classnames';

const Loader = () => {
    return (<div>
            <div className={'circleGA'}>
                <div className={classNames('circleG', 'circleG1')} />
                <div className={classNames('circleG', 'circleG2')} />
                <div className={classNames('circleG', 'circleG3')} />
            </div>
            <div className={'underCunstruct'}>
                Раздел в разработке
            </div>
        </div>
    )
}

export default Loader;


// WEBPACK FOOTER //
// ./src/shared/Loader/Loader.js